/* =============================================================================
 * Tusq Apparel — PDP v2 *additions* only
 * Handles the bottom sticky ATC bar visibility + state sync with the primary
 * Add-to-Cart button. The existing tusq-modal handles the size chart drawer.
 * ============================================================================= */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // ---------------------------------------------------------------------------
  // Sticky ATC visibility — observe when the primary ATC scrolls off-screen
  // ---------------------------------------------------------------------------
  function initStickyATC() {
    var sticky = document.querySelector('[data-tusq-sticky-atc]');
    if (!sticky) return;

    var primaryATC =
      document.querySelector('product-info .product-form__submit') ||
      document.querySelector('product-info .product-form button[type="submit"]') ||
      document.querySelector('.product-form__submit');

    if (!primaryATC) {
      // Fallback: scroll-distance threshold
      window.addEventListener('scroll', function () {
        var show = window.scrollY > 600;
        sticky.dataset.visible = show ? 'true' : 'false';
        sticky.removeAttribute('hidden');
      }, { passive: true });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var rect = entry.boundingClientRect;
        var showSticky = !entry.isIntersecting && rect.top < 0;
        sticky.dataset.visible = showSticky ? 'true' : 'false';
        if (showSticky) sticky.removeAttribute('hidden');
      });
    }, { threshold: 0, rootMargin: '0px 0px -50px 0px' });

    observer.observe(primaryATC);
  }

  // ---------------------------------------------------------------------------
  // Sync sticky CTA label and disabled state with primary ATC
  // ---------------------------------------------------------------------------
  function initStickySync() {
    var primary =
      document.querySelector('product-info .product-form__submit') ||
      document.querySelector('.product-form__submit');
    var stickyCta = document.querySelector('[data-tusq-sticky-cta]');
    if (!primary || !stickyCta) return;

    function syncState() {
      var disabled = primary.getAttribute('aria-disabled') === 'true' || primary.disabled;
      var label = (primary.querySelector('span:not(.hidden):not([class*="sold"])') || primary).textContent.trim();
      stickyCta.disabled = !!disabled;
      if (label) stickyCta.textContent = label;
    }
    syncState();

    var mo = new MutationObserver(syncState);
    mo.observe(primary, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  ready(function () {
    initStickyATC();
    initStickySync();
  });
})();
